import { apiRequest } from "../client";
import type { PDFGenerateParams } from "./types";

/**
 * Generate a PDF from a template
 * @param params PDF generation parameters
 * @returns Promise resolving to a Blob containing the PDF
 */
export async function generatePDF(params: PDFGenerateParams): Promise<Blob> {
  const urlParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      urlParams.append(key, String(value));
    }
  });

  return apiRequest<Blob>({
    method: "GET",
    url: `/pdf/generate?${urlParams.toString()}`,
    responseType: "blob",
  });
}

// Export types
export type {
  PDFGenerationParams,
  BatchPDFRequest,
  BatchPDFProgress,
  BatchPDFResult,
  BatchPDFAsyncStartResponse,
  BatchPDFAsyncStatusResponse,
  BatchPDFTaskListItem,
  BatchPDFTaskListResponse,
  BatchPDFResultDetails,
  SinglePDFAsyncRequest,
  PdfGenerationStage,
  BatchPDFTaskStatus,
} from "./types";

// Export helper functions
export {
  getResultDetails,
  isActivePdfBatchTaskStatus,
  isCompletedPdfBatchTaskStatus,
  getPdfBatchTaskStatusLabel,
  taskHasDownloadableFile,
} from "./types";

// Export batch PDF service
export { batchPDFService, BatchPDFService } from "./batchPDFService";
